import { registerComponent } from "helpers";

/**
 * 1. Yotpo reviews widget struggles to init when in a hidden element, and ends up overflowing the panel.
 *    It listens for viewport resize to re-render, so we are triggering that.
 */

registerComponent(
  "wyatt-accordion",
  class WyattAccordion extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll("[data-accordion-button]");

      this.buttons.forEach((button) => {
        button.addEventListener("click", this.handleClick.bind(this));
      });
    }

    handleClick(event) {
      const button = event.currentTarget;
      const isOpen = button.getAttribute("aria-expanded") === "true";

      this.toggle(button, isOpen);
    }

    toggle(button, isOpen) {
      const index = button.dataset.accordionButton;
      const group = this.querySelector(`[data-accordion-group="${index}"]`);

      if (isOpen) {
        group.classList.remove("active");
        button.setAttribute("aria-expanded", false);
      } else {
        if (index === "reviews") {
          window.dispatchEvent(new Event("resize"));
        }

        group.classList.add("active");
        button.setAttribute("aria-expanded", true);
      }
    }
  },
);
